import { ExpenseBasicDetailsFragment } from 'generated/resources/graphql'

export const getBasicDetailsDefaultValues = (data?: ExpenseBasicDetailsFragment | null) => {
  return {
    documentType: data?.expense?.documentType ?? '',
  }
}
